import React from 'react';
import { Constants } from '@pwc/pwc-deals-web-common';
import classNames from 'classnames';
import UnableToLoadContent from '../../../../features/analyses/common/UnableToLoadContent/UnableToLoadContent';
import OneColumnLayout from '../OneColumnLayout';
import MultipleColumnLayout from '../MultipleColumnLayout/MultipleColumnLayout';
import { layoutConfigs } from './constants';
import './Section.scss';

export default function Section({
  projectId,
  analysisId,
  section,
  isLoading,
  hasError,
}) {
  const layoutConfig = layoutConfigs[section.layoutType];
  const { columnPositionClassMap, containerClass } = layoutConfig;
  const isOneColumnLayout = [
    Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN,
    Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80,
    Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60,
    Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40,
    Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA,
    Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A,
    Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A,
    Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A,
    Constants.SECTION_LAYOUT_TYPE.THREE_ROWS,
  ].includes(section.layoutType);
  const isMultipleColumnLayout = containerClass && columnPositionClassMap;

  if (isOneColumnLayout) {
    return (
      <div
        className={classNames(
          'section-onecolumn2',
          { 'd-none': section && section.items && !section.items.length },
          containerClass
        )}
        data-testid="section-one-column"
      >
        <OneColumnLayout
          projectId={projectId}
          analysisId={analysisId}
          items={section.items}
          isLoading={isLoading}
          hasError={hasError}
        />
      </div>
    );
  }

  if (isMultipleColumnLayout) {
    return (
      <MultipleColumnLayout
        columnPositionClassMap={columnPositionClassMap}
        containerClass={containerClass}
        projectId={projectId}
        analysisId={analysisId}
        items={section.items}
        isLoading={isLoading}
        hasError={hasError}
      />
    );
  }

  return (
    <UnableToLoadContent
      placeId="content-error-section"
      projectId={projectId}
    />
  );
}
